import {AutocompleteInput,Filter,Loading,useDataProvider} from 'react-admin'
import {useEffect,useState} from 'react'
import {ActionTitles} from '../Constants'
import {width} from '../Styles'
import * as React from 'react'
import { Error404 } from '../errors/Error404'

export const RiskInsightsAdminFilter = (props) => {
  const dataProvider = useDataProvider();
  const [partnerChoices, setPartnerChoices] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    dataProvider
      .getClientNameList("admin/client/names")
      .then(({ data }) => {
        setPartnerChoices(data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [dataProvider]);

  if (loading) return <Loading />;
  if (error) return <Error404 />;

  return (
    <Filter {...props}>
      <AutocompleteInput
        source="clientId"
        name="clientId" //check this while integration
        variant="outlined"
        size="small"
        label={ActionTitles.CORPORATE_PARTNER}
        choices={partnerChoices}
        resettable
        alwaysOn
        sx={width.fixed.w300}
      />
    </Filter>
  );
}